/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Description1Inputs */

const id_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih notifikasi yang ingin Anda terima untuk penawaran ini.`)
};

const ms_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih pemberitahuan yang anda mahu terima untuk tawaran ini.`)
};

const da_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg hvilke notifikationer du vil modtage for dette tilbud.`)
};

const de_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie, welche Benachrichtigungen Sie für dieses Angebot erhalten möchten.`)
};

const en_us2_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what notifications you want to receive for this offer.`)
};

const es_es2_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige qué notificaciones quieres recibir para este contenido.`)
};

const es_mx2_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige qué notificaciones quieres recibir para esta oferta.`)
};

const fil_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili kung anong mga notipikasyon ang gusto mong matanggap para sa offer na ito.`)
};

const fr_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez les notifications que vous souhaitez recevoir pour cette offre.`)
};

const it_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli quali notifiche ricevere per questa offerta.`)
};

const hu_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válaszd ki, milyen értesítéseket szeretnél kapni ehhez az ajánlathoz.`)
};

const nl_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies welke meldingen je wilt ontvangen voor dit aanbod.`)
};

const no_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg hvilke varsler du vil motta for dette tilbudet.`)
};

const pl_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz, jakie powiadomienia chcesz otrzymywać dla tej oferty.`)
};

const pt_br2_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha quais notificações você quer receber para este conteúdo.`)
};

const pt_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha quais notificações pretende receber para esta oferta.`)
};

const ro_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alege ce notificări dorești să primești pentru această ofertă.`)
};

const fi_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse, mitä ilmoituksia haluat saada tästä tarjouksesta.`)
};

const sv_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj vilka notiser du vill få för detta erbjudande.`)
};

const vi_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn thông báo bạn muốn nhận cho ưu đãi này.`)
};

const tr_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu teklif için almak istediğiniz bildirimleri seçin.`)
};

const cs_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte, jaká oznámení chcete pro tuto nabídku dostávat.`)
};

const bg_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете какви известия искате да получавате за тази оферта.`)
};

const ru_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите, какие уведомления вы хотите получать для этого предложения.`)
};

const uk_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть, які сповіщення ви хочете отримувати для цієї пропозиції.`)
};

const ar_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر الإشعارات التي تريد تلقيها لهذا العرض.`)
};

const hi_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चुनें कि आप इस ऑफ़र के लिए कौन सी सूचनाएँ प्राप्त करना चाहते हैं।`)
};

const th_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกการแจ้งเตือนที่คุณต้องการรับสำหรับข้อเสนอนี้`)
};

const ja_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオファーに対して受け取る通知を選択してください。`)
};

const zh_cn2_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择您希望接收此目录项的哪些通知。`)
};

const zh_hant1_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇您希望接收此目錄項目的哪些通知。`)
};

const ko_offerdetail_notifications_description1 = /** @type {(inputs: Offerdetail_Notifications_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 오퍼에 대해 수신할 알림을 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Choose what notifications you want to receive for this offer." |
*
* @param {Offerdetail_Notifications_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_description1 = /** @type {((inputs?: Offerdetail_Notifications_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_description1(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_description1(inputs)
	if (locale === "da") return da_offerdetail_notifications_description1(inputs)
	if (locale === "de") return de_offerdetail_notifications_description1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_description1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_description1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_description1(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_description1(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_description1(inputs)
	if (locale === "it") return it_offerdetail_notifications_description1(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_description1(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_description1(inputs)
	if (locale === "no") return no_offerdetail_notifications_description1(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_description1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_description1(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_description1(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_description1(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_description1(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_description1(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_description1(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_description1(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_description1(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_description1(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_description1(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_description1(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_description1(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_description1(inputs)
	if (locale === "th") return th_offerdetail_notifications_description1(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_description1(inputs)
	return ko_offerdetail_notifications_description1(inputs)
});
export { offerdetail_notifications_description1 as "offerDetail.notifications.description" }